var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34232 3.16435C2.43113 2.82095 2.52172 2.51953 2.60372 2.26872C3.81216 3.76047 5.32583 4.98171 7.04697 5.84802C9.04585 6.85413 11.2625 7.35027 13.4996 7.29226C13.7706 7.28524 13.9866 7.06352 13.9866 6.79243V5.56637H13.9867L13.9866 5.55967C13.9729 4.53698 14.2736 3.53475 14.848 2.68853C15.4225 1.84231 16.243 1.19293 17.1985 0.828216C18.1541 0.463503 19.1986 0.401055 20.1908 0.649316C21.183 0.897578 22.075 1.44457 22.7462 2.21632C22.8752 2.36471 23.0793 2.42367 23.2676 2.36696C24.245 2.07265 25.1855 1.67171 26.0725 1.17228C25.6155 2.28737 24.9366 3.30332 24.072 4.15596C23.9532 4.27315 23.9006 4.44191 23.932 4.60584C23.9902 4.91069 24.0201 5.22029 24.0212 5.53066C24.0208 12.405 20.7427 17.287 16.1636 19.7243C12.0757 21.9001 6.91066 22.1486 2.0307 20.0679C4.46826 19.8252 6.81869 18.9787 8.86322 17.5908C9.01343 17.4889 9.09657 17.3135 9.08043 17.1327C9.06428 16.9518 8.95138 16.794 8.78548 16.7202C6.1068 15.5297 4.42521 13.982 3.39177 12.3502C2.35631 10.7153 1.95242 8.96556 1.8788 7.34597C1.80508 5.72421 2.06327 4.24333 2.34232 3.16435Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5a4006582379a342c3eb581fd6d71145.svg";
export { ForwardRef as ReactComponent };